import { chains } from "app/chains";
import { fallback, http } from "viem";
import { customRpc } from "./customRpcMap";

const BSC_HTTP_URLS = [
  customRpc[56],
  "https://bsc.publicnode.com",
  "https://bsc-dataseed.binance.org",
  "https://bsc-mainnet.public.blastapi.io",
].filter(Boolean) as string[];

type Transport =
  | ReturnType<typeof http>
  | ReturnType<typeof fallback>;

export const transports: Record<number, Transport> = chains.reduce(
  (map, chain) => {
    if (chain.id === 56) {
      map[56] = fallback(BSC_HTTP_URLS.map((url) => http(url)));
    } else {
      const url = customRpc[chain.id] ?? chain.rpcUrls.default.http[0];
      map[chain.id] = http(url);
    }
    return map;
  },
  {} as Record<number, Transport>
);
